import React from 'react';
import {Route} from 'react-router-dom';
import AsyncList from '../../../business/news/list/async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route
    key="/:type(consumer)/news/list"
    element={
      <DefaultConsumerLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'News List',
            item: '/consumer/news/list',
          },
        ]}
      />
    }
  >
    <Route path="consumer/news/list" element={<AsyncList />} />
  </Route>
);
